// src/reducers/admin_reducer.js
import {
  RECEIVE_ADMIN_SUMMARY,
  RECEIVE_PENDING_STUDENTS,
  REMOVE_PENDING_STUDENT,
  RECEIVE_PENDING_MASTERS,
  RECEIVE_ACTIVE_STUDENTS,
  RECEIVE_ACTIVE_MASTERS,
  ADMIN_ERRORS,
} from '../actions/admin_actions';

const initialState = {
  summary: {
    pendingCount: 0,
    totalStudents: 0,
    enrolledStudents: 0,
    // master stats may also be present from backend
    totalMasters: 0,
    pendingMasters: 0,
    approvedMasters: 0,
  },
  pendingStudents: [],
  pendingMasters: [],
  activeStudents: [],
  activeMasters: [],
  errors: [],
};

const adminReducer = (state = initialState, action) => {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_ADMIN_SUMMARY:
      return {
        ...state,
        summary: {
          ...state.summary,
          ...action.summary,
        },
      };

    case RECEIVE_PENDING_STUDENTS:
      return {
        ...state,
        pendingStudents: action.students,
      };

    case REMOVE_PENDING_STUDENT:
      return {
        ...state,
        pendingStudents: state.pendingStudents.filter(
          (s) => s._id !== action.studentId
        ),
        summary: {
          ...state.summary,
          pendingCount: Math.max((state.summary.pendingCount || 0) - 1, 0),
        },
      };

    case RECEIVE_PENDING_MASTERS:
      return {
        ...state,
        pendingMasters: action.masters,
      };

    case RECEIVE_ACTIVE_STUDENTS:
      return {
        ...state,
        activeStudents: action.students,
      };

    case RECEIVE_ACTIVE_MASTERS:
      return {
        ...state,
        activeMasters: action.masters,
      };

    case ADMIN_ERRORS:
      return {
        ...state,
        errors: Array.isArray(action.errors)
          ? action.errors
          : [action.errors],
      };

    default:
      return state;
  }
};

export default adminReducer;
